<template>
  <account-home
    :tabs="tabs"
  >
    <base-table
      v-if="showMobile"
      class="loan-applications-mobile"
    >
      <tbody>
        <tr
          v-for="(loanApp, i) in loanApplications"
          :key="i"
        >
          <div>
            <span>{{ $t('pages.loan_applications.id') }}</span>
            <span>{{ loanApp.loan_application_id }}</span>
          </div>
          <div>
            <span>{{ $t('pages.loan_applications.date') }}</span>
            <span>{{ dateFormat(loanApp.created_at) }}</span>
          </div>
          <div>
            <span>{{ $t('pages.loan_applications.amount') }}</span>
            <span>{{ amount(loanApp) }}</span>
          </div>
          <div>
            <span>{{ $t('pages.loan_applications.installments') }}</span>
            <span>{{ num_installments(loanApp) }}</span>
          </div>
          <div>
            <span>{{ $t('pages.loan_applications.status') }}</span>
            <span>
              <span
                :class="'loan-application-status-' + status(loanApp)"
              >
                {{ $t('pages.loan_applications.' + status(loanApp)) }}
              </span>
            </span>
          </div>
        </tr>
      </tbody>
    </base-table>
    <base-table
      v-if="!showMobile"
      class="loan-applications"
      :striped-odd="true"
    >
      <thead>
        <tr>
          <th>{{ $t('pages.loan_applications.id') }}</th>
          <th>{{ $t('pages.loan_applications.date') }}</th>
          <th>{{ $t('pages.loan_applications.amount') }}</th>
          <th>{{ $t('pages.loan_applications.installments') }}</th>
          <th>{{ $t('pages.loan_applications.status') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(loanApp, i) in loanApplications"
          :key="i"
        >
          <td>{{ loanApp.loan_application_id }}</td>
          <td>{{ dateFormat(loanApp.created_at) }}</td>
          <td>{{ amount(loanApp) }}</td>
          <td>{{ num_installments(loanApp) }}</td>
          <td>
            <span
              :class="'loan-application-status-' + status(loanApp)"
            >
              {{ $t('pages.loan_applications.' + status(loanApp)) }}
            </span>
          </td>
        </tr>
      </tbody>
    </base-table>
  </account-home>
</template>

<script>
import { get } from 'vuex-pathify';
import AccountHome from '../components/AccountHome.vue';
import currencyReals from '../filters/currencyReals';
import BaseTable from '../components/_baseTable.vue';

export default {
  components: { BaseTable, AccountHome },
  data() {
    return {
      windowWidth: window.innerWidth,
      statuses:    {
        approved:    ['lp_approved'],
        declined:    ['ebs_declined', 'lp_declined', 'underwriting_declined'],
        in_progress: ['ready_for_lp', 'lp', 'approved', 'pending'],
      },
    };
  },
  computed: {
    loanApplications: get('loanApplications'),
    loanApplication:  get('loanApplication'),
    tabs() {
      const tabs = [
        { name: this.$t('pages.account_home.tabs.loan_applications'), url: '/loan_applications' },
      ];

      if (this.loanApplication && this.loanApplication.opt_in_status) {
        tabs.push({ name: this.$t('pages.account_home.tabs.opt_in'), url: '/loan_application/opt_in' });
      }

      return tabs;
    },
    showMobile() {
      return this.windowWidth < 700;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize());
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize());
  },
  methods: {
    onResize() {
      return () => { this.windowWidth = window.innerWidth; };
    },
    dateFormat(date) {
      const options = {
        month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit',
      };
      const d = new Date(date);
      return d.toLocaleString('pt-BR', options);
    },
    amount(loanApp) {
      if (typeof loanApp.loan_agreement !== 'undefined' && loanApp.loan_agreement != null) {
        return currencyReals(loanApp.loan_agreement.amount);
      }

      if (typeof loanApp.loan_offers !== 'undefined' && loanApp.loan_offers !== null && loanApp.loan_offers.length > 0) {
        return currencyReals(loanApp.loan_offers[0].min_amount);
      }

      return currencyReals(loanApp.requested_loan_amount);
    },
    num_installments(loanApp) {
      if (typeof loanApp.loan_agreement !== 'undefined' && loanApp.loan_agreement != null) {
        const loanOffer = this.lodash.find(
          loanApp.loan_offers,
          (offer) => offer.loan_offer_id === loanApp.loan_agreement.loan_offer_id,
        );

        if (typeof loanOffer !== 'undefined' && loanOffer !== null) {
          return loanOffer.num_installments;
        }
      }

      if (typeof loanApp.loan_offers !== 'undefined' && loanApp.loan_offers !== null && loanApp.loan_offers.length > 0) {
        return loanApp.loan_offers[0].num_installments;
      }

      return loanApp.requested_loan_duration;
    },
    status(loanApp) {
      let { status } = loanApp;
      Object.keys(this.statuses).forEach((key) => {
        if (this.lodash.includes(this.statuses[key], loanApp.status)) {
          status = key;
        }
      });

      return status;
    },
  },
};
</script>

<style lang="scss" scoped>
  .base-table.loan-applications.striped-odd {
    margin-top: 12px;
    border: none;

    thead {
      font-weight: bold;
      border-bottom: 2px solid #ddd;
      tr {
        background-color: #ffffff;
      }
      th {
        vertical-align: bottom;
      }
    }
  }

  .base-table.loan-applications-mobile {
    margin-top: 12px;
    border: none;

    tr {
      padding-top: 12px;
      border-bottom: 2px solid #dfdfdf;

      div {
        display: grid;
        grid-template-columns: 50% 50%;

        span {
          padding: 8px 12px;
        }

        span:nth-of-type(1) {
          font-weight: bold;
        }

        span:nth-of-type(2) {
          text-align: right;
        }
      }

      div:nth-of-type(2n) {
        background-color: #efefef;
      }
    }
  }
</style>
